
import CreatePostModalWrapper from './CreatePostModalWrapper';
import SelectProfileModalWrapper from './SelectProfileModalWrapper';
import MentionCardWrapper from './MentionCardWrapper';
import CreatePortfolioModalWrapper from './CreatePortfolioModalWrapper';
import PasswordResetModalWrapper from './PasswordResetModalWrapper';
import CreatePortfolioOperationModalWrapper from './CreatePortfolioOperationModalWrapper';
import UILegalDisclaimerModal from '~/components/ui/organism/UILegalDisclaimerModal.vue';
import PortfolioEmptyStateModal from '~/components/shared/modals/PortfolioEmptyStateModal.vue';
import NewsUpdateModalWrapper from '~/components/shared/modals/NewsUpdateModalWrapper.vue';
import HelpCenterWrapper from '~/components/ui/helpCenter/HelpCenterWrapper.vue';
import CompareTickersModalWrapper from './CompareTickersModalWrapper.vue';
import ComparePortfoliosModalWrapper from './ComparePortfoliosModalWrapper.vue';
import ManageTeamPortfolioModalWrapper from './ManageTeamPortfolioModalWrapper';
import CreateLeagueModalWrapper from './CreateLeagueModalWrapper';
import CompanyTickersListModal from './CompanyTickersListModal.vue';
import NotificationsMenuDrawer from '~/components/ui/molecule/NotificationsMenuDrawer.vue';
import PortfolioGuideModal from '~/components/ui/modal/PortfolioGuideModal.vue';
import HomePageGuideDrawer from '~/components/ui/molecule/HomePageGuideDrawer.vue';
import MobileSidebar from '~/components/shared/modals/MobileSidebar.vue';
import PortfolioUnrankInfo from '~/components/ui/molecule/PortfolioUnrankInfo.vue';
import { mapGetters, mapActions } from 'vuex';
import { isMobileResponsive } from '~/utils/mixins';
import PortfolioSettingsModal from '~/components/ui/molecule/PortfolioSettingsModal.vue';
import UnrankedPortfolioConfirmationComponent from '~/components/ui/molecule/UnrankedPortfolioConfirmationComponent.vue';
import NoEligiblePortfolioDrawer from '~/components/ui/molecule/NoEligiblePortfolioDrawer.vue';
import NoEligiblePortfolioModal from '~/components/ui/molecule/NoEligiblePortfolioModal.vue';
import UIOrderBookModal from '~/components/ui/organism/UIOrderBookModal.vue';
import UIPortfolioSelectorModal from '~/components/ui/organism/UIPortfolioSelectorModal.vue';
import TransactionTypesModal from '~/components/ui/modal/TransactionTypesModal.vue';

export default {
  name: 'Modals',
  components: {
    MentionCardWrapper,
    SelectProfileModalWrapper,
    CreatePostModalWrapper,
    CreatePortfolioModalWrapper,
    // ImageSliderModalWrapper,
    PasswordResetModalWrapper,
    CreatePortfolioOperationModalWrapper,
    PortfolioEmptyStateModal,
    NewsUpdateModalWrapper,
    HelpCenterWrapper,
    CompareTickersModalWrapper,
    ComparePortfoliosModalWrapper,
    UILegalDisclaimerModal,
    ManageTeamPortfolioModalWrapper,
    CreateLeagueModalWrapper,
    CompanyTickersListModal,
    NotificationsMenuDrawer,
    PortfolioGuideModal,
    HomePageGuideDrawer,
    MobileSidebar,
    PortfolioUnrankInfo,
    PortfolioSettingsModal,
    UnrankedPortfolioConfirmationComponent,
    NoEligiblePortfolioDrawer,
    NoEligiblePortfolioModal,
    UIOrderBookModal,
    UIPortfolioSelectorModal,
    TransactionTypesModal,
  },
  mixins: [isMobileResponsive],
  computed: {
    ...mapGetters('onboarding', ['hasCompletedTutorial']),
    ...mapGetters('authentication', ['profile', 'isUserAdmin']),
    ...mapGetters('modals', [
      'passwordResetModal',
      'createPortfolioOperationModal',
      'portfolioEmptyStateModal',
      'showLegalDisclaimerModal',
      'helpCenterObjectRes',
      'compareTickersModal',
      'comparePortfoliosModal',
      'manageTeamPortfolioModal',
      'showCreatePostModalRes',
      'createLeagueModal',
      'companyTickersListModal',
      'notificationsCenterMenuDrawer',
      'portfolioGuideModal',
      'homePageGuideDrawer',
      'mobileSidebar',
      'portfolioOperationConfirmationComponent',
      'portfolioSettingsModal',
      'unrankedPortfolioConfirmationComponent',
      'noEligiblePortfoliosDrawer',
      'noEligiblePortfolioModal',
      'createOrderTransactionModal',
      'createOrderModal',
      'portfolioSelectorModal',
      'showTransactionTypesModal',
    ]),
    routeName() {
      return this.$route.name?.split('_')[0];
    },
    showPortfolioEmptyStateModal() {
      return (
        this.portfolioEmptyStateModal.show &&
        ['portfolios'].indexOf(this.routeName) != -1
      );
    },
  },
  methods: {
    ...mapActions('modals', [
      'toggleHomePageGuideDrawer',
      'toggleMobileSidebar',
      'showCreatePortfolioOperationModal',
      'submitPortfolioOperationForm',
      'showCreatePortfolioModal',
    ]),
    ...mapActions('portfolio', [
      'validatePortfolioItemAddition',
      'validatePortfolioOperation',
    ]),
    async handleAddPortfolioItem(itemPayload) {
      await this.validatePortfolioItemAddition({
        commitTransaction: true,
        ...itemPayload,
      });

      this.handleClosePortfolioOperationModal(
        payload.transactionModalShouldStayOpen
      );
    },
    async handleAddPortfolioOperation(payload) {
      if (payload.validateAllocation) {
        await this.validatePortfolioOperation({
          commitTransaction: true,
          itemId: payload.itemId,
          ...payload.operationPayload,
        });

        this.handleClosePortfolioOperationModal(
          payload.transactionModalShouldStayOpen
        );
      } else {
        this.submitPortfolioOperationForm(
          payload.transactionModalShouldStayOpen
        );
      }
    },
    handleClosePortfolioOperationModal(shouldStayOpen) {
      console.log('should stay open', shouldStayOpen);
      if (!shouldStayOpen) {
        this.showCreatePortfolioOperationModal({ show: false });
      } else {
        const modalPayload = {
          symbol: null,
          portfolioType: null,
          show: false,
          currency: '',
        };
        this.showCreatePortfolioOperationModal(modalPayload);
      }
    },
    handleOpenTransactionModal() {
      const payload = {
        symbol: this.portfolioSelectorModal.selectedTicker,
        show: true,
        portfolio: this.portfolioSelectorModal.selectedPortfolio,
        shouldShowTickerCard: true,
      };

      this.showCreatePortfolioOperationModal(payload);
    },
    handleShowPortfolioModal() {
      this.showCreatePortfolioModal();
    },
    handleShowTransactionTypesModal() {
      this.showCreatePortfolioOperationModal({ show: false });
    },
  },
};
